//Core
import React, { useEffect, useState } from "react";
import { format } from "date-fns";

//Styles
import "./styles.scss";

// Redux
import { useDispatch, useSelector } from "react-redux";
import { getAssessmentTrackerListRequest_ACCESSOR } from "../../../../Redux/Slices/Accessor/accessorSlice";

//Component
import Button from "Components/Button";
import InputBox from "Components/InputBox";
import MainLayout from "Layouts/Main";
import NormalTable from "Components/NormalTable";
import FilterDrawer from "Components/FilterDrawer";
import moment from "moment-timezone";

const AssessmentTracker = () => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState([]);
  const [selectedIndustry, setSelectedIndustry] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [assementTrackerList, setAssementTrackerList] = useState([]);
  const [search, setSearch] = useState("");
  const [activeFilters, setActiveFilters] = useState({
    status: "",
    company: "",
    industry: "",
    fromDate: null,
    toDate: null
  });
  const [sort, setSort] = useState({
    sortBy: null,
    sortOrder: 0,
  });
  const isLoading = useSelector((state) => state.accessor.isLoading);

  const handleFilterOpen = () => {
    setOpen(true);
  };

  useEffect(() => {
    getAssessmentTrackerListRequest_ACCESSOR_(
      currentPage, 
      search,
      activeFilters.fromDate,
      activeFilters.toDate,
      activeFilters.status,
      activeFilters.company,
      activeFilters.industry
    );
  }, [sort, currentPage, search, activeFilters]);

  const assessmentTrackerHeader = [
    { label: "S.No", isSort: false, key: "sno" },
    { label: "Company Name", isSort: false, key: "company_name" },
    { label: "Assessment Name", isSort: false, key: "assessment_name" },
    { label: "Reference Number", isSort:false, key: "reference_name",  headerStyle: { paddingInline: "15px"},},
    { label: "Creation Date", isSort: false, key: "createdAt", },
    { label: "Due Date", isSort: false, key: "due_date", },
    { label: "User Status", isSort: false, key: "status", headerStyle: { marginInline: "auto" }, },
  ];

  const getDisplayedIndex = (currentPage, index) => {
    const startingIndex = (currentPage - 1) * 8 + 1;
    return startingIndex + index;
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
    setCurrentPage(1); // Reset to first page on new search
  };

  const getAssessmentTrackerListRequest_ACCESSOR_ = (
    page,
    search,
    fromDate,
    toDate,
    status,
    company,
    industry
  ) => {
    dispatch(
      getAssessmentTrackerListRequest_ACCESSOR({
        page: page,
        search,
        sortBy: sort.sortOrder === 1 ? "ASC" : "DESC",
        orderBy: sort.sortBy,
        start_date: fromDate ? moment(fromDate).tz("Asia/Kolkata").format("YYYY-MM-DD") : "",
        due_date: toDate ? moment(toDate).tz("Asia/Kolkata").format("YYYY-MM-DD") : "",
        status: status,
        company_type_name: company,
        industry_name: industry,
        callBack: getAssessmentTrackerListRequestCB_ACCESSOR,
      })
    );
  };

  const getAssessmentTrackerListRequestCB_ACCESSOR = (data) => {
    setTotalPages(data?.data?.pageMeta?.totalPages);
    setAssementTrackerList(data?.data?.data);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleFilterApply = (
    formattedStatus,
    formattedCompany,
    formattedIndustry
  ) => {
    setActiveFilters({
      status: formattedStatus,
      company: formattedCompany,
      industry: formattedIndustry,
      fromDate: fromDate,
      toDate: toDate
    });
    setCurrentPage(1); // Reset to first page when applying new filters
    setOpen(false);
  };

  const handleFilterClear = () => {
    setFromDate(null);
    setToDate(null);
    setSelectedCompany([]);
    setSelectedIndustry([]);
    setSelectedStatus([]);
    setActiveFilters({
      status: "",
      company: "",
      industry: "",
      fromDate: null,
      toDate: null
    });
    setCurrentPage(1); // Reset to first page when clearing filters
  };

  return (
    <MainLayout>
      <div className="assessment-tracker-container mt-3 ps-4 ms-2">
        <div className="row">
          <div className="col-5">
            <label className="assessmentTrackerTitle">
              {" "}
              Assessment Tracker
            </label>
          </div>
          <div className="col-7">
            <div className="d-flex justify-content-end">
              <div className="me-3">
                <InputBox
                  name="search"
                  isSearch={true}
                  placeholder="Search"
                  value={search}
                  onChange={(e) => handleSearch(e)}
                  inputStyle={{ width: "277px" }}
                />
              </div>

              <Button
                title="Filter"
                outlineButton={true}
                isFilter={true}
                onClick={handleFilterOpen}
                titleStyle={{
                  fontSize: "16px",
                }}
                buttonStyle={{
                  width: "160px",
                  padding: "0",
                }}
              />
            </div>
          </div>
        </div>

        <div className="mt-5">
          <NormalTable
            loading={isLoading === "loading"}
            headers={assessmentTrackerHeader}
            sort={sort}
            setSort={setSort}
            currentPage={currentPage}
            noDataColspan={9}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
            customStyle={{
              customTableHeaderContainer: "customTable",
              customHeaderTitle: "customHeaderStartTitle",
              customTable: "customTable",
              customTableContainer: "customTableContainer",
            }}
            noDataLabel={assementTrackerList?.length === 0}
          >
            {assementTrackerList?.map((item, index) => {
              const statusClassName =
                item.status === 3
                  ? "completedStatus"
                  : item?.status === 2
                  ? "progressStatus"
                  : "pendingStatus";
              return (
                <tr key={index}>
                  <td>
                    <div className="TableDivisionStart mx-3 mt-1 ">
                      {getDisplayedIndex(currentPage, index)}
                    </div>
                  </td>
                  <td>
                    <div className="TableDivisionStart ms-2 mt-1">
                      {item?.company_name ?? "-"}
                    </div>
                  </td>
                  <td>
                    <div className="TableDivisionStart ms-2 mt-1">
                      {item?.assessment_name ?? "-"}
                    </div>
                  </td>
                                    <td>
                    <div className="TableDivisionStart ms-2 mt-1" style={{ paddingInline:"15px"}}>
                      {item?.reference_name ?? "-"}
                    </div>
                  </td>
                  <td>
                    <div className="TableDivisionStart ms-2 mt-1 ">
                      {!!item?.createdAt
                        ? moment.utc(item?.createdAt).tz("Asia/Kolkata").format("DD/MM/YYYY")
                        : "-"}
                    </div>
                  </td>

                  <td>
                    <div className="TableDivisionStart ms-2 mt-1 ">
                        {!!item?.due_date
                          ? moment.utc(item?.due_date).tz("Asia/Kolkata").format("DD/MM/YYYY")
                          : "-"}
                    </div>
                  </td>

                  <td>
                    <div className={`TableDivision ${statusClassName}`} style={{marginInline:"auto"}}>
                      {item?.status === 3
                        ? "Completed"
                        : item?.status === 2
                        ? "In-progress"
                        : "Pending"}
                    </div>
                  </td>
                </tr>
              );
            })}
          </NormalTable>

          <FilterDrawer
            show={open}
            handleClose={() => setOpen(false)}
            title={"Filter"}
            dateFrom={fromDate}
            setDateFrom={setFromDate}
            dateTo={toDate}
            setDateTo={setToDate}
            selectedStatus={selectedStatus}
            setSelectedStatus={setSelectedStatus}
            selectedIndustry={selectedIndustry}
            setSelectedIndustry={setSelectedIndustry}
            selectedCompany={selectedCompany}
            setSelectedCompany={setSelectedCompany}
            handleApply={handleFilterApply}
            handleClear={handleFilterClear}
          />
        </div>
      </div>
    </MainLayout>
  );
};

export default AssessmentTracker;
